import "../../Styles/ClientSetupHeader.css";
import { IoChevronBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

function ClientSetupHeader({currentStep}) {
  const navigate = useNavigate();
  return (
    <div className="client-setup-header-main">
      <div className="client-setup-header-left">
        {currentStep !== 3 && currentStep !== 4 && <IoChevronBackOutline
          className="client-setup-back-icon"
          onClick={() =>
            navigate("/client-profile-selection", {
              replace: true,
            })
          }
        />}

        <img
          src={require("../../assests/images/nav_bar_logo.png")}
          alt="Wedluk Logo"
          className="client-setup-logo"
        />
      </div>

      <div className="client-setup-header-right">
        {/* <span>Client Sign up | Client setup</span> */}
      </div>
    </div>
  );
}

export default ClientSetupHeader;
